"use client";

import { adminDeleteDocument } from "@/api";
import { appState } from "@/app/appState";
import { chatState } from "@/app/chatState";
import { usePathParam } from "@/components/path-params";
import { EntryList } from "@/components/UI/tools";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { PageBox } from "@/components/UI/page";

const DocumentsList = observer(() => {
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [documentSearch, setDocumentSearch] = useState<string>("");
    const [id, setId] = usePathParam("documents");
    const [ids, setIds] = useState<number[]>([]);

    const deleteSelectedDocuments = async () => {
        setDeleting(true);
        try {
            for (const documentId of ids) {
                await adminDeleteDocument({ body: { document_id: documentId } });
            }
            appState.documents = appState.documents.filter((x) => !ids.includes(x.id));
            chatState.forgetDeletedObjects(ids.map((id) => ({ type: "document", id })));
            setIds([]);
        } catch {
            appState.setModal({ title: appState.t("common.error"), body: appState.t("objects.errorDeleteDocuments") });
        } finally {
            setDeleting(false);
        }
    };

    useEffect(() => {
        appState.getDocuments({ pageNumber: 0, search: documentSearch });
    }, [id, documentSearch]);

    return (
        <PageBox onScrollToBottom={() => appState.getDocuments({ pageNumber: appState.documents_page + 1, search: documentSearch })}>
            <div id="document" className="h-full w-full">
                <EntryList
                    name={appState.t("objects.list.document")}
                    readonly={![4, 5, 6, 7].includes(appState.user?.active_organisation.permission_type ?? 0)}
                    deleteonly={true}
                    loading={loading}
                    deleting={deleting}
                    search={{ get: documentSearch, set: setDocumentSearch }}
                    deleteEntries={deleteSelectedDocuments}
                    idParams={{
                        singular: { get: id, set: setId },
                        plural: { get: ids, set: setIds },
                    }}
                    items={appState.documents?.map((x) => {
                        return {
                            id: x.id,
                            lock: false,
                            val: x.variable_name + (x.tag_name ? ` [${x.tag_name}]` : ""),
                            readonly: ![4, 5, 6, 7].includes(x.permission_type ?? 0),
                            showonly: ![2, 3, 4, 5, 6, 7].includes(x.permission_type ?? 0),
                        };
                    })}
                />
            </div>
        </PageBox>
    );
});

export default DocumentsList;
